import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  justifyContent: 'center',
};

export const icon: SxStyle = {
  color: (p) => p.palette.primary[300],
  cursor: 'pointer',
  transitionDuration: '0.2s',
  '&:hover': {
    color: (p) => p.palette.primary[500],
  },
};
